module.exports = __webpack_public_path__ + "img/download-1-CHAPP.9e85d5a3.png";